export const router = [{
  path: 'index',
  component: resolve => require(['./Index.vue'], resolve)
}]
